import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "stillform_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authed = () => {
  const c = axios.create({ baseURL: API });
  c.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return c;
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data;
};

export const adminMe = async () => (await authed().get("/auth/me")).data;

export const adminList = async (kind) => (await authed().get(`/admin/${kind}`)).data;
export const adminCreate = async (kind, payload) =>
  (await authed().post(`/admin/${kind}`, payload)).data;
export const adminUpdate = async (kind, slug, payload) =>
  (await authed().put(`/admin/${kind}/${slug}`, payload)).data;
export const adminDelete = async (kind, slug) =>
  (await authed().delete(`/admin/${kind}/${slug}`)).data;

export const adminSubscribers = async () =>
  (await authed().get("/admin/subscribers/all")).data;
export const adminOrders = async () =>
  (await authed().get("/admin/orders/all")).data;

export const adminGenerateImage = async ({ prompt, target_type, target_slug }) =>
  (await authed().post("/admin/generate-image", { prompt, target_type, target_slug })).data;

